<template>
    <div class="list-raovat list-hoidap">
        <fillterHoidap
        :idSelect="idSelect"
        v-model="data_fillter"/>
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web',
                'table-mobile': $detect == 'mobile'
            }">
            <thead>
                <tr v-if="$detect == 'web'">
                    <th scope="col" class="text-center">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                                id="select-all-table" v-model="selectAll"/>
                            <label class="custom-control-label" for="select-all-table"></label>
                        </div>
                    </th>
                    <th scope="col">ID</th>
                    <th scope="col">Câu hỏi</th>
                    <th scope="col" class="text-center">Cập nhật</th>
                    <th scope="col" class="text-center">Lượt xem</th>
                    <th scope="col" class="text-center">Trả lời</th>
                    <!-- <th scope="col" class="text-center">Hành động</th> -->
                    <th scope="col" class="text-center">Trạng thái</th>
                    <th scope="col" class="text-center">Thao tác</th>
                </tr>
                <tr v-else>
                    <th class="px-0 py-1">
                        <div class="d-flex flex-thead">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                    id="select-all-table" v-model="selectAll"/>
                                <label class="custom-control-label" for="select-all-table"></label>
                            </div>
                            <div class="thead-info text-center">
                                <p class="mb-0">Thông tin</p>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="hoidap.length == 0">
                <tr>
                    <td colspan="9" class="text-center text-muted">Không có dữ liệu</td>
                </tr>
            </tbody>
            <tbody v-else-if="$detect == 'web'">
                <tr :class="{
                    'pending': item.status == 0 || item.status == 2
                }" v-for="(item, index) in hoidap" :key="index">
                    <td scope="row" style="white-space: nowrap;" width="50">
                        <div class="custom-control custom-checkbox text-center" v-if="item.status == 1 && item.check_action">
                            <input type="checkbox" class="custom-control-input" :id="item.id" :value="item.id" v-model="idSelect"/>
                            <label class="custom-control-label" :for="item.id"></label>
                        </div>
                    </td>
                    <td class="position-relative" width="72">
                        <p class="mb-0 fw-600">{{ item.id }}</p>
                    </td>
                    <td class="name-hd">
                        <div>
                            <a class="text-decoration-none" :href="$linkUrl(item.link)" target="_blank">
                                <p class="name-item mb-0" v-html="item.name"></p>
                            </a>
                        </div>
                    </td>
                    <td class="text-center" width="120">
                        <p class="mb-0">{{ item.last_up }}</p>
                    </td>
                    <td colspan="2" class="text-center" v-if="item.status == 0 || item.status == 2" width="420">
                        <p class="mb-0" v-if="item.status == 2 && item.approve !== null">
                            <span class="mr-2">Lý do:</span>
                            <span class="text-danger">{{ item.approve }}</span>
                        </p>
                    </td>
                    <td class="text-center" width="100" v-if="item.status == 1">
                        <p class="mb-0">{{ $formatNumber(item.hits) }}</p>
                    </td>
                    <td class="text-center" width="100" v-if="item.status == 1">
                        <p class="mb-0">{{ $formatNumber(item.reply) }}</p>
                    </td>
                    <!-- <td class="text-center" width="220" v-if="item.status == 1">
                        <button class="btn btn-info btn-sm px-2 mr-1 fs-14px">Up lên đầu</button>
                        <button class="btn btn-primary btn-sm px-2 ml-1 fs-14px">Tự động Up</button>
                    </td> -->
                    <td class="text-center" width="120">
                        <p class="text-success mb-0 fw-600" v-if="item.status == 1">Đã duyệt</p>
                        <p class="mb-0 fw-600" v-else-if="item.status == 0">Chờ duyệt</p>
                        <p class="mb-0 fw-600 text-danger" v-else>Không duyệt</p>
                    </td>
                    <td class="text-center" width="140">
                        <button type="button" class="btn btn-success btn-sm px-3 mr-2"
                            @click="update(item)">
                            <i :class="{
                                'icon': true,
                                'ion-md-create': item.check_action,
                                'ion-ios-eye': !item.check_action
                            }"></i>
                        </button>
                        <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destroy(item, index)" :disabled="index === loading && loadingAction == 'destroy'">
                            <i class="icon ion-md-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr :class="{
                    'pending': item.status == 0 || item.status == 2
                    }" v-for="(item, index) in hoidap" :key="index">
                    <td class="px-0">
                        <div class="d-flex align-items-center">
                            <div class="custom-control custom-checkbox checkbox-tab" v-if="item.status == 1 && item.check_action">
                                <input type="checkbox" class="custom-control-input" :id="item.id" :value="item.id" v-model="idSelect">
                                <label class="custom-control-label" :for="item.id"></label>
                            </div>
                            <div :class="{
                                    'name-tab-mobile': item.status == 1,
                                    'w-100': item.status == 0 || item.status == 2
                                }">
                                <a class="text-decoration-none" :href="item.link" target="_blank">
                                    <p class="mb-0 text-dark fw-600" v-html="item.name"></p>
                                </a>
                                <div class="status mt-2">
                                    <div class="d-flex justify-content-between">
                                        <div>#{{ item.id }}</div>
                                        <div><i class="icon ion-md-time mr-1"></i>{{ item.last_up }}</div>
                                    </div>
                                </div>
                                <div class="view-answer mt-2">
                                    <div :class="{
                                            'd-flex': true,
                                            'justify-content-between': item.status == 1 || item.status == 2,
                                            'flex-row-reverse': item.status == 0,

                                        }">
                                        <div v-if="item.status == 1">
                                            <i class="icon ion-md-eye mr-1"></i>
                                            {{ $formatNumber(item.hits) }}
                                            <span class="mx-3">-</span>
                                            <i class="icon ion-ios-chatboxes mr-1"></i>
                                            {{ $formatNumber(item.reply) }}
                                        </div>
                                        <div class="text-approve" v-if="item.status == 2">
                                            <p class="mb-0 approve-mobile">
                                                <span class="mr-1"><i class="icon ion-md-alert text-danger"></i></span>
                                                <span class="text-danger">{{ item.approve }}</span>
                                            </p>
                                        </div>
                                        <div class="text-success fw-600" v-if="item.status == 1">Đã duyệt</div>
                                        <div class="fw-600" v-else-if="item.status == 0">Chờ duyệt</div>
                                        <div class="fw-600 text-danger" v-else>Không duyệt</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div :class="{
                                'd-flex btn-action-table mt-2 justify-content-between': true,
                            }">
                            <div :class="{
                                'w-div-approve' : item.status == 0 || item.status == 2
                            }">
                                <button class="btn btn-info btn-sm fs-14px btn-block" v-if="item.status == 1">Up lên đầu</button>
                            </div>
                            <div :class="{
                                'w-div-approve-1' : item.status == 0 || item.status == 2
                            }">
                                <button class="btn btn-primary btn-sm fs-14px btn-block" v-if="item.status == 1">Tự động Up</button>
                            </div>
                            <div class="mr-2">
                                <button type="button" class="btn btn-success btn-sm btn-block px-3">
                                    <i class="icon ion-md-create d-none"></i>Sửa
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-danger btn-sm btn-block px-3">
                                    <i class="icon ion-md-trash d-none"></i>Xoá
                                </button>
                            </div>
                        </div> -->
                        <div class="btn-action-hd mt-2">
                            <button type="button" class="btn btn-success btn-sm w-btn mr-2"
                                @click="update(item)">
                                <i :class="{
                                    'icon mr-2 fs-16px': true,
                                    'ion-md-create': item.check_action,
                                    'ion-ios-eye': !item.check_action
                                }"></i>{{item.check_action ? 'Sửa' : 'Xem'}}
                            </button>
                            <button type="button" class="btn btn-danger btn-sm w-btn ml-2"
                                @click="destroy(item, index)" :disabled="index === loading && loadingAction == 'destroy'">
                                <i class="icon ion-md-trash mr-2 fs-16px"></i>Xoá
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getDataFaq"/>
    </div>
</template>
<script>
import { destroy, notAction } from '@/config/hoidap';
export default {
    components: {
        fillterHoidap: () => import('./fillter.vue'),
        paginate: () => import('@/components/layout/pagination.vue'),
    },
    data(){
        return {
            hoidap: [],
            idSelect: [],
            last_page: 0,
            next_page: 0,
            current_page: 0,
            selectAll: false,
            data_fillter: {},
            loading: false,
            loadingAction: '',
        }
    },
    created() {
        this.getDataFaq(1);
        this.$eventBus.$on('call-hd-current-page', () => {
            this.getDataFaq(this.current_page);
        })
    },
    methods: {
        async getDataFaq(page) {
            let params = {
                page: page,
                fillter: this.data_fillter.fillter,
                keyword: this.data_fillter.keyword,
                category: this.data_fillter.category,
            };
            this.idSelect = [];
            this.selectAll = false;
            await apiGet('/v2/profile/hoidap', params).then(res => {
                this.hoidap = res.data;
                this.last_page = res.last_page;
                this.next_page = res.next_page;
                this.current_page = res.current_page;
                this.selectAll = false;
            })
        },
        async destroy(hoidap, index){
            /* if(!hoidap.check_action){
                notAction();
                return;
            } */
            this.loadingAction = 'destroy';
            this.loading = index;
            await destroy(hoidap.id, this);
            this.loadingAction = '';
            this.loading = false;
        },
        update(hoidap){
            if(hoidap.check_action){
                this.$router.push({
                    name: 'hoidap-update',
                    params: {id: hoidap.id}
                })
            }else{
                window.open(this.$linkUrl(hoidap.link), '_target')
            }
        }
    },
    watch: {
        data_fillter: {
            handler(val){
                this.getDataFaq(1)
            },
            deep: true
        },
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.hoidap.map(item => {
                    if(item.status == 1 && item.check_action){
                        this.idSelect.push(item.id);
                    }
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.hoidap.map(item => {
                    if(item.status == 1){
                        count += 1;
                    }
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
    }
}
</script>
<style lang="scss">
    .list-hoidap {
        td {
            vertical-align: middle;
        }
        .name-hd {
            .name-item {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .btn-dropdown-action {
            &:hover {
                background: #ebf1fd !important;
            }
        }
        .table-mobile {
            .name-tab-mobile {
                width: calc(100% - 40px);
                p {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .checkbox-tab {
                width: 40px;
            }
            .flex-thead {
                .custom-checkbox {
                    width: 40px;
                }
                .thead-info {
                    width: calc( 100% - 40px );
                }
            }
            .approve-mobile {
                display: -webkit-box !important;
                -webkit-line-clamp: 1 !important;
                -webkit-box-orient: vertical !important;
                overflow: hidden !important;
                text-overflow: ellipsis !important;
            }
            .btn-action-approve {
                width: 103px;
            }
            .text-approve {
                width: calc( 100% - 103px );
            }
            .w-div-approve {
                width: 88.6px;
            }
            .w-div-approve-1 {
                width: 94px;
            }
            .btn-action-hd {
                .w-btn {
                    width: calc( 50% - 8px);
                }
            }
        }
    }
</style>
